import React, { Component } from "react";
import classnames from "classnames";
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { loginUser } from "../../actions/authActions";
import { showMainErrorPop } from '../../actions/popups';
import SessionDataStore from "../../streaming/SessionDataStoreController";
import Util from "../../streaming/Util";

class LoginContent extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		emailInput: '',
		passwordInput: '',
		showPassword: false,
		errorEmail: false,
		focusedElement: '',
		facebookLogin: '', 
		facebookLoginUrl: process.env.REACT_APP_ADMINURL+"/login#ContinueWithFacebook",
		appleLoginUrl: process.env.REACT_APP_ADMINURL+"/login#continueWithApple"
    }
	
	this.sessionDataStore = SessionDataStore.getInstance();
}
 
componentDidMount(){
	localStorage.removeItem('sessionData');
    localStorage.removeItem('deeplinkRef');
    localStorage.setItem("remindLog", true);
	localStorage.removeItem("video-resolution");
    localStorage.removeItem("showMicrophoneAlert");
	
	if ( this.props.auth.isAuthenticated )
		{
			let localstoragedata = JSON.parse(localStorage.getItem('userData'));
			
			const userData = {
				userId: localstoragedata.id,
				auth: localstoragedata.token
			};
			
			this.props.updateStateFromChild({showLoader: true});
			this.props.loginUser(userData);
		}
	else
		{
			setTimeout(() => {
				if ( window['electron'] && window['deeplinkingParams'] == undefined )
					{
						let localstoragedata = JSON.parse(localStorage.getItem('userData'));
						if ( localstoragedata !== null )
							{
								const userData = {
									userId: localstoragedata.id,
									auth: localstoragedata.token
								};
								
								console.log('logging user---', userData);
								
								this.props.updateStateFromChild({showLoader: true});
								this.props.loginUser(userData);
							}
					}
			}, 1000);
		}	
	document.addEventListener("keydown", this.keyDownHandler);
	
	if ( localStorage.getItem('lastRememberedEmail') && !this.props.auth.isAuthenticated )
		{
			let rememberedEmail = localStorage.getItem('lastRememberedEmail');
			this.setState({
				emailInput: rememberedEmail,
			});
		}
	
	
	window.addEventListener("message", (event) => {
	  if ( event && event.data )
		{
			try {
				var recData = JSON.parse(event.data);
				console.log(recData);
				
				if ( recData.source && recData.userData && recData.source == 'auto-login' )
					{
						let localstoragedata = JSON.parse(recData.userData);
						if ( localstoragedata !== null && localstoragedata.data && localstoragedata.data.responseData )
							{
								const userData = {
									userId: localstoragedata.data.responseData.id,
									auth: localstoragedata.data.responseData.token
								};
								
								console.log('logging user---', userData);
								
								this.props.updateStateFromChild({showLoader: true});
								this.props.loginUser(userData);
							}
					}
				
			} catch (err) { console.log(err); }
		}
	}, false);
}

keyDownHandler = (event) => {
	if ( event.keyCode == 9 )
		{
			if ( this.state.focusedElement == 'email' ) 
				{
					document.getElementById("passwordInput").focus();
					return false;
				}
				
			if ( this.state.focusedElement == 'password' ) 
				{
					document.getElementById("emailInput").focus();
					return false;
				}
		}
}

componentWillReceiveProps(nextProps) {
	this.props.updateStateFromChild({showLoader: false});
	
	if ( nextProps.auth.isAuthenticated ) 
		{
			var localstoragedata = JSON.parse(localStorage.getItem('userData'));
			if ( localstoragedata && localstoragedata.onDemandData && localstoragedata.onDemandData.ondemandId != undefined && !localstoragedata.hasLiveAndOnDemand )
				{
					let addObject = {"sessionId": localstoragedata.onDemandData.ondemandId , "event": "status", "eventType": "login", "userId": localstoragedata.id, "details": JSON.stringify({"status":"success"}), "timestamp": Util.getCurrentTimestamp()};
					this.sessionDataStore.addSessionData(addObject);
					if ( localstoragedata.onDemandData.ondemandId != undefined ) 
						{
							var storage = JSON.parse(localStorage.getItem('userData'));
							storage.sessionData = JSON.parse(JSON.stringify(storage.onDemandData));
							localStorage.setItem("userData", JSON.stringify(storage));
							console.log('ondemand1');
							this.props.history.push("/pre-screen");
						}
					else 
						{
							this.props.history.push("/pre-screen");
						}
				}
			else if( localstoragedata && localstoragedata.sessionData && ( localstoragedata.sessionData.id != undefined ) && !localstoragedata.hasLiveAndOnDemand )
				{
					let addObject = {"sessionId": localstoragedata.sessionData.id, "event": "status", "eventType": "login", "userId": localstoragedata.id, "details": JSON.stringify({"status":"success"}), "timestamp": Util.getCurrentTimestamp()};
					this.sessionDataStore.addSessionData(addObject);
					
					
					let joinDuration = localstoragedata.default.streamJoiningDefaultTime * 60000;
					var startDateTime = new Date(new Date(localstoragedata.sessionData.scheduleDate).getTime() - joinDuration);
					var timeLeft = Math.ceil(Math.round( (new Date(startDateTime).getTime() - new Date().getTime()) / 1000 ) / 60 );
					
					if ( timeLeft <= 0 )
						{
							if ( window['deeplinkingParams'] !== undefined ) 
								{ 
									this.props.history.push("/pre-screen"); 
								}
							else
								{ 
									this.props.history.push("/home#mySchedule"); 
								}
						}
					else
						{
							this.props.history.push("/home");
						}
				}
			else
				{
					this.props.history.push("/home");		
				}
		}
	
	if ( nextProps.errors && Object.keys(nextProps.errors).length > 0 && nextProps.errors !== '' ) 
		{
			if ( window.location.href.indexOf('/home') > -1 || window.location.href.indexOf('/pre-screen') > -1 ) { return false; }
			this.props.showMainErrorPop(nextProps.errors);
			let addObject = {"sessionId": 1, "event": "error", "eventType": "login", "details": JSON.stringify({"email": this.state.emailInput, "status":"fail", "msg":nextProps.errors}), "timestamp": Util.getCurrentTimestamp()};
			this.sessionDataStore.addSessionData(addObject);
			this.sessionDataStore.dumpData();
		}
}


validateEmail=(mail)=>{
	var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
	if ( mail.match(validRegex) ) 
		{
			return true;
		}
		
	return false;
}

submitForm=(e, facebookStatus)=>{
	e.preventDefault();
	var canSubmitLogin = true;
	if ( !this.validateEmail(this.state.emailInput.trim()) )
		{
			canSubmitLogin = false;
			this.setState({errorEmail: true});
			this.props.showMainErrorPop('Please enter valid email.');
		}
	if ( canSubmitLogin || facebookStatus ) 
		{
			const userData = {
				email: this.state.emailInput.trim(),
				password: this.state.passwordInput.trim(),
				type: "1",
				facebookLogin: facebookStatus ? this.state.facebookLogin : '',
			};
			
			this.props.updateStateFromChild({showLoader: true});
			this.props.loginUser(userData);
		}
}

submitFailed=(e)=>{
	e.preventDefault();
	if ( !this.validateEmail(this.state.emailInput.trim()) )
		{
			this.setState({errorEmail: true});
			this.props.showMainErrorPop('Please enter valid email.');
		}
		
	if ( !this.state.passwordInput.length == 0 )
		{
			this.setState({errorEmail: true});
			this.props.showMainErrorPop('Please enter password.');
		}		
}

deeplinking=()=>{
	console.log('start deeplinking...');
	if ( window['deeplinkingParams'] !== undefined )
		{
			console.log('deeplinking params---', window['deeplinkingParams']);
			let userId = window['deeplinkingParams'][0].split('=')[1];
			let tokenData = window['deeplinkingParams'][1].split('#')[0];
			let userToken = tokenData.split('=')[1];
			
			const userData = {
				userId: userId,
				auth: userToken
			};
			
			console.log('logging user deeplink---', userData);
			
			if ( window['deeplinkingParams'][2] !== undefined )
				{
					let param2 = window['deeplinkingParams'][2].split('=');
					if ( param2[0] == 'ondemandId' )
						{
							userData.onDemandId = param2[1];
						}
					else
						{
							localStorage.setItem('deeplinkRef', param2[1].split('#')[0]);
						}
				}
				
			document.removeEventListener("mousedown", this.keyDownHandler, true);
			this.props.updateStateFromChild({showLoader: true});
			this.props.loginUser(userData);
		}
}

loginFacebook = (e) =>
	{
		if ( window.FB )
			{
				var mainThis = this;
				window.FB.login(function(response)
					{
						if ( response && response.authResponse && response.authResponse.accessToken )
							{
								mainThis.setState({facebookLogin: response.authResponse.accessToken}, ()=>{
									mainThis.submitForm(e, true);
								});	
							}
						
					}, {scope: 'public_profile,email'});
				
			}
	}

  render() {
	 return (
		<div className="memberRegisterHolder loginMainPage" id="mainLogContent">
			{
				/* <div className="exit_content">
					<div className="inline_event">
						<div className="arrow_exit"></div>
						<div className="exit_screen">EXIT</div>
					</div>
				</div> */	
			}
			<div className="sign_title">Sign in</div>
			{ /* <div className="sign_subtitle">{"Don't have accout?"} <span>Join Virdio</span></div> */ }
			<form className="form_login_content" role="form" onSubmit={(e) => (this.state.emailInput == '' || this.state.passwordInput == '') ? this.submitFailed(e) : this.submitForm(e)}>
				<div className="one_form_container">
					<div className="form_title">Email</div>
					<div className="relative_holder">
						<input type="text" tabIndex="1" className={classnames({'gray_inputs': true, 'error_input': this.state.errorEmail})} id="emailInput" value={this.state.emailInput} onChange={(e)=>this.setState({[e.target.id]:e.target.value, errorEmail: false})} onFocus={() => this.setState({focusedElement: 'email'})} onBlur={() => this.setState({focusedElement: ''})} />
						{ this.state.emailInput !== '' &&
							<div className="empty_input" onClick={()=>this.setState({emailInput: ""})}></div>
						}
					</div>
				</div>
				<div className="one_form_container">
					<div className="form_title">Password</div>
					<div className="relative_holder">
						<input type={this.state.showPassword ? "text" : "password"} tabIndex="2" className="gray_inputs" id="passwordInput" value={this.state.passwordInput} onChange={(e)=>this.setState({[e.target.id]:e.target.value})} onFocus={() => this.setState({focusedElement: 'password'})} onBlur={() => this.setState({focusedElement: ''})} />
						<div className="eye_show" id="showPassword" onClick={(e)=>this.setState({[e.target.id]: !this.state.showPassword})}>
							{ this.state.showPassword && <div className="crossed_eye"></div> }
						</div>
					</div>
				</div>
				
				<div className="bottomLoginPadding">
					<div className="loginBottomHolders">
						<div className="info_row_holder">
							<div className="one_form_container">
								<Link to="/forgot-password">
									<div className="form_title forgotClickHolder">Forgot password?</div>
								</Link>
							</div>
						</div>
					</div>
					<div className="loginBottomHolders">					
						<div className="sing_in_content">
							<button type="submit" className={classnames({'signNewButton': true, 'opacity_event': this.state.emailInput == '' || this.state.passwordInput == ''})}>
								<div className="">Sign in</div>
							</button>
						</div>
					</div>
				</div>
				<div className="borderMainHolder">
					<div className="bottomBorderPart"></div>
					<div className="orTextPart">OR</div>
					<div className="bottomBorderPart"></div>
				</div>
				<div className="registerOtherHolder">
					<a href={this.state.facebookLoginUrl} target={ window['electron'] ? '_blank' : '_self' }>	
						<div className="fbButtonPart">
							<div className="fbLogoImg"></div>
							<div className="fbText">Continue with Facebook</div>
						</div>
					</a>
					
					<a href={this.state.appleLoginUrl} target={ window['electron'] ? '_blank' : '_self' }>	
						<div className="fbButtonPart">
							<div className="fbLogoImg appleLogo"></div>
							<div className="fbText">Continue with Apple</div>
						</div>
					</a>
				</div>
			</form>
			<span id="deeplink" onClick={this.deeplinking.bind(this)}></span>
		</div>
    );
  }
}

LoginContent.propTypes = {
  loginUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default connect(
  mapStateToProps,
  { loginUser, showMainErrorPop }
)(LoginContent);
